import Types from "./Types";

const INITIAL_STATE = {
  exams: [],
  manualExams: [],
  examQuestions: [],
  studentExams: [],
  exam: {},
  isLoading: false,
  essayAnswers: [],
  essayAnswersLoading: false,
  publishLoading: false,
  restrictLoading: false,
  enableLoading: false,
  count: "",
};

export default function exams(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.GET_EXAMS_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
        count: payload.data.length,
      };
    }

    case Types.GET_ALL_EXAM_QUESTIONS_SUCCESS: {
      console.log(payload);
      return {
        ...state,
        examQuestions: payload.data,
      };
    }

    case Types.GET_EXAMS_SUPER_ADMIN_SUCCESS: {
      return {
        ...state,
        exams: payload.data,
        count: payload.data.length,
      };
    }
    case Types.GET_ADMIN_STUDENT_EXAMS_SUCCESS: {
      return {
        ...state,
        studentExams: payload.data,
        count: payload.data.length,
      };
    }

    case Types.RESTRICT_EXAM_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.ENABLE_EXAM_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.GET_EXAM_SUCCESS: {
      return {
        ...state,
        exam: payload,
      };
    }

    case Types.EDIT_EXAM_SUCCESS: {
      let data = payload.data;
      const replaceExam = (list) => {
        if (!Array.isArray(list)) return list;
        const idx = list.findIndex((table) => table.id === data.id);
        if (idx === -1) return list;
        const next = list.slice();
        next[idx] = data;
        return next;
      };
      return {
        ...state,
        exams: replaceExam(state.exams),
        manualExams: replaceExam(state.manualExams),
      };
    }

    // create
    case Types.CREATE_EXAM_SUCCESS: {
      const data = payload.data.data;
      let newArray = state.exams.slice();
      let index = state.exams.length + 1;
      newArray.splice(index, 0, data);
      const manualExams =
        String(data?.type) === "5"
          ? [data, ...(Array.isArray(state.manualExams) ? state.manualExams : [])]
          : state.manualExams;
      return {
        ...state,
        exams: newArray,
        manualExams,
      };
    }
    case Types.CREATE_EXAM_QUESTIONS_SUCCESS: {
      const data = payload.data.data;

      return {
        ...state,
      };
    }
    case Types.ADD_EXAMS_LOADING: {
      return {
        ...state,
        isLoading: payload,
      };
    }

    case Types.DELETE_EXAM_SUCCESS: {
      const newexams = state.exams.filter((item) => item.id !== payload);
      return {
        ...state,
        exams: newexams,
      };
    }

    case Types.PUBLISH_EXAM_LOADING: {
      return {
        ...state,
        publishLoading: payload,
      };
    }
    case Types.RESTRICT_EXAM_LOADING: {
      return {
        ...state,
        restrictLoading: payload,
      };
    }

    case Types.ENABLE_EXAM_LOADING: {
      return {
        ...state,
        enableLoading: payload,
      };
    }

    case Types.PUBLISH_EXAM_SUCCESS: {
      let id = payload.payload;
      let data = payload.result.data.data;
      const patchPublish = (list) => {
        if (!Array.isArray(list)) return list;
        const idx = list.findIndex((table) => table.id === id);
        if (idx === -1) return list;
        const next = list.slice();
        next[idx] = {
          ...next[idx],
          auto_publish_result: data?.auto_publish_result,
        };
        return next;
      };
      return {
        ...state,
        exams: patchPublish(state.exams),
        manualExams: patchPublish(state.manualExams),
      };
    }
    case Types.EDIT_EXAM_QUESTION_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.ADD_BULK_CORRECTION_SUCCESS: {
      return {
        ...state,
      };
    }
    case Types.GET_MANUAL_EXAMS_SUCCESS: {
      return {
        ...state,
        manualExams: Array.isArray(payload?.data) ? payload.data : [],
      };
    }
    case Types.GET_MANUAL_EXAMS_MARKS_SUCCESS: {
      return {
        ...state,
        marks: payload.data,
      };
    }
    case Types.SET_MANUAL_EXAM_MARK_SUCCESS: {
      return {
        ...state,
      };
    }

    case Types.GET_ESSAY_ANSWERS_REQUEST: {
      return {
        ...state,
        essayAnswersLoading: true,
        essayAnswers: [],
      };
    }
    case Types.GET_ESSAY_ANSWERS_SUCCESS: {
      return {
        ...state,
        essayAnswers: payload?.data || [],
        essayAnswersLoading: false,
      };
    }
    case Types.GET_ESSAY_ANSWERS_FAIL: {
      return {
        ...state,
        essayAnswers: [],
        essayAnswersLoading: false,
      };
    }

    case Types.PUBLISHED_EXAM_REQUEST: {
      return {
        ...state,
      };
    }

    case Types.ENABLE_REDO_REQUEST: {
      return {
        ...state,
      };
    }

    default: {
      return state;
    }
  }
}
